"use client";
import React, { useEffect } from "react";
import "./index.css";
import BaseLayout from "@/components/baseLayout";

const StaticLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <BaseLayout>
      <div className="h-screen overflow-auto bg-gradient-to-b from-blue-50 via-white to-red-50">
        <div className="sticky top-0 z-10">
          <Header />
        </div>
        <div className="h-full">
          {children}
          <div>
            <Footer />
          </div>
        </div>
      </div>
    </BaseLayout>
  );
};

const Header = () => {
  useEffect(() => {
    // 汉堡菜单逻辑
    const hamburger = document.querySelector(".hamburger-menu");
    const navLinks = document.querySelector(".nav-links");

    if (hamburger && navLinks) {
      const handleClick = () => {
        navLinks.classList.toggle("active");
        const bars = document.querySelectorAll(".hamburger-menu .bar");
        bars.forEach((bar) => {
          bar.classList.toggle("change");
        });
      };
      hamburger.addEventListener("click", handleClick);

      // 点击导航链接后关闭菜单
      const links = document.querySelectorAll(".nav-links a");
      links.forEach((link) => {
        link.addEventListener("click", () => {
          navLinks.classList.remove("active");
          const bars = document.querySelectorAll(".hamburger-menu .bar");
          bars.forEach((bar) => {
            bar.classList.remove("change");
          });
        });
      });

      // 清理事件
      return () => {
        hamburger.removeEventListener("click", handleClick);
        links.forEach((link) => {
          link.removeEventListener("click", () => { });
        });
      };
    }
  }, []);

  return (
    <>
      {/* Combined Header and Navigation */}
      <nav className="nav-menu w-full shadow-sm sticky top-0 z-10 bg-white/95 backdrop-blur border-b border-blue-100">
        <div className="logo-container flex items-center">
          <a
            href="/"
            className="title tracking-tight flex items-center text-gray-900"
            aria-label="RightNow Home"
          >
            <img
              src="/images/logo.png"
              alt="RightNow logo"
              height={48}
              width={48}
              className="rounded-lg mr-2"
            />
            <span className="flex flex-col leading-tight">
              <span className="font-[800] times-new-roman mr-2">
                <span className="text-[#E50024] ">RIGHT</span>
                <span className="text-[#013388] ">NOW</span>
              </span>
            </span>
          </a>
        </div>
        <div className="hamburger-menu">
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
        <div className="nav-links">
          <a href="/terms" className="text-gray-700 hover:text-[#013388]">
            Terms of Use
          </a>
          <a href="/privacy" className="text-gray-700 hover:text-[#013388]">
            Privacy Policy
          </a>
          <a href="/standards" className="text-gray-700 hover:text-[#013388]">
            Community Standards
          </a>
          <a href="/legal-notices" className="text-gray-700 hover:text-[#013388]">
            Legal Notices
          </a>
          <a href="/dsmi" className="text-gray-700 hover:text-[#013388]">
            Your Privacy Choices
          </a>
          <a href="/trust-center" className="text-gray-700 hover:text-[#013388]">
            Trust Center
          </a>
        </div>
      </nav>
    </>
  );
};

const Footer = () => {
  return (
    <section className="bg-white py-8 mt-8 border-t border-blue-100">
      <div className="text-center text-gray-600 text-sm">
        <div className="mb-2 font-semibold text-[#013388]">
          RightNow: News You Can Trust
        </div>
        <b>Contact Us</b>
        <br />
        Email:
        <a
          href="mailto:feedback@rightnownewsapp.com"
          className="text-blue-600 underline"
        >
          feedback@rightnownewsapp.com
        </a>
        <a href="/contact" className="ml-3 text-blue-600 underline">
          Contact
        </a>
        <br />
        Address:
        <span className="text-blue-600 underline">
          800 W El Camino Real, Suite 300 Mountain View, CA 94040
        </span>
      </div>
      <div className="text-center text-gray-400 text-xs mt-2 pb-5">
        RightNow Copyright  © 2025 Life Agents, LLC
      </div>
    </section>
  );
};

export default StaticLayout;
